module.exports = __webpack_public_path__ + "static/media/_spinner.dce47622.scss";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/all/custom/_spinner.scss
// module id = 1078
// module chunks = 0